import React, { useEffect, useState } from "react";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import "../firebase/firebase";
import "./styles/orders.css";

const filters = [
  { label: "Last 24 Hours", value: "24h" },
  { label: "Last 7 Days", value: "7d" },
  { label: "Last 30 Days", value: "30d" },
  { label: "All", value: "all" },
  { label: "Price: Low to High", value: "priceLow" },
  { label: "Price: High to Low", value: "priceHigh" },
  { label: "Brand: FesiShop", value: "fesishop" },
  { label: "Brand: RH110", value: "resin" },
];

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [expandedIndex, setExpandedIndex] = useState(null);

  const db = getFirestore();

  useEffect(() => {
    const fetchOrders = async () => {
      const querySnapshot = await getDocs(collection(db, "orders"));
      const data = querySnapshot.docs.map((doc) => doc.data());
      setOrders(data);
      setFiltered(data);
    };
    fetchOrders();
  }, [db]);

  useEffect(() => {
    let filteredOrders = [...orders];
    const now = new Date();

    if (filterType === "24h") {
      filteredOrders = orders.filter(
        (order) =>
          order.createdAt.toDate() > new Date(now - 24 * 60 * 60 * 1000)
      );
    } else if (filterType === "7d") {
      filteredOrders = orders.filter(
        (order) =>
          order.createdAt.toDate() > new Date(now - 7 * 24 * 60 * 60 * 1000)
      );
    } else if (filterType === "30d") {
      filteredOrders = orders.filter(
        (order) =>
          order.createdAt.toDate() > new Date(now - 30 * 24 * 60 * 60 * 1000)
      );
    } else if (filterType === "priceLow") {
      filteredOrders = [...orders].sort((a, b) => {
        const priceA = a.products[0]?.productPrice || 0;
        const priceB = b.products[0]?.productPrice || 0;
        return priceA - priceB;
      });
    } else if (filterType === "priceHigh") {
      filteredOrders = [...orders].sort((a, b) => {
        const priceA = a.products[0]?.productPrice || 0;
        const priceB = b.products[0]?.productPrice || 0;
        return priceB - priceA;
      });
    } else if (filterType === "fesishop") {
      filteredOrders = orders.filter(
        (order) => order.products[0]?.brand?.toLowerCase() === "fesishop"
      );
    } else if (filterType === "resin") {
      filteredOrders = orders.filter(
        (order) => order.products[0]?.brand?.toLowerCase() === "resin"
      );
    }

    setFiltered(filteredOrders);
  }, [filterType, orders]);

  const toggleExpanded = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="order-history">
      <h2>Order History</h2>

      <div className="filters">
        {filters.map((f) => (
          <button
            key={f.value}
            className={`pill ${filterType === f.value ? "active" : ""}`}
            onClick={() => setFilterType(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="order-list">
        {filtered.map((order, index) => {
          const firstProduct = order.products[0];
          const isExpanded = expandedIndex === index;
          const shipping = order.shipping || {};

          const createdAt = order.createdAt?.toDate();
          const dateString = createdAt?.toLocaleDateString();
          const timeString = createdAt?.toLocaleTimeString();

          return (
            <div key={index} className="order-pill">
              <div className="pill-header">
                <div>
                  <strong>{firstProduct?.productTitle}</strong> |{" "}
                  <span className="brand">{firstProduct?.brand}</span> |{" "}
                  <span className="price">
                    Rs. {firstProduct?.productPrice}
                  </span>{" "}
                  | <span className="timestamp">{dateString}</span>
                </div>

                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <a
                    href={firstProduct?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="product-link"
                    style={{ color: "#fff", textDecoration: "underline" }}
                  >
                    View
                  </a>
                  <button
                    className="expand-btn"
                    onClick={() => toggleExpanded(index)}
                  >
                    {isExpanded ? "Hide" : "View Details"}
                  </button>
                </div>
              </div>

              {isExpanded && (
                <div className="pill-details">
                  <div className="order-meta">
                    <div className="meta-section">
                      <h4>Customer</h4>
                      <p>
                        <strong>Name:</strong> {shipping.firstName}{" "}
                        {shipping.lastName}
                      </p>
                      <p>
                        <strong>Email:</strong> {shipping.email}
                      </p>
                      <p>
                        <strong>Contact:</strong> {order.contact || "N/A"}
                      </p>
                    </div>
                    <div className="meta-section">
                      <h4>Shipping</h4>
                      <p>
                        <strong>Address:</strong> {shipping.address}
                      </p>
                      <p>
                        <strong>City:</strong> {shipping.city}
                      </p>
                      <p>
                        <strong>Postal Code:</strong> {shipping.postal}
                      </p>
                    </div>
                  </div>
                  {order.products.map((p, i) => (
                    <div key={i} className="product-detail">
                      <div className="orderLabel">
                        <h4>{i + 1}</h4>
                      </div>
                      <img src={p.productImage} alt={p.productTitle} />
                      <div>
                        <p>
                          <strong>Title:</strong> {p.productTitle}
                        </p>
                        <p>
                          <strong>Brand:</strong> {p.brand}
                        </p>
                        <p>
                          <strong>Price:</strong> Rs. {p.productPrice}
                        </p>
                        <p>
                          <strong>Color:</strong> {p.color}
                        </p>
                        <p>
                          <strong>Quantity:</strong> {p.quantity}
                        </p>
                        <p>
                          <strong>Date:</strong> {dateString}
                        </p>
                        <p>
                          <strong>Time:</strong> {timeString}
                        </p>
                        <a
                          href={p.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Product Link
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Orders;
